module.exports = __webpack_public_path__ + "img/puppy-how-to-get.56ae11cb.png";